import React, {FC, useMemo, useState} from 'react'
import {Link, useNavigate} from 'react-router-dom'
import {
  buildPayoutDetailPath,
  resolvePayoutPlatformAsync,
  resolvePayoutPlatformSync,
} from './resolvePayoutPlatform'
import {PayoutDetailNavigationState} from './types'
import {getSettlementOrPayoutId} from './utils'

interface PayoutSettlementLinkProps {
  row: any
  connectedPlatforms: any[]
  routePlatformId?: string
  returnTo: string
}

export const PayoutSettlementLink: FC<PayoutSettlementLinkProps> = ({
  row,
  connectedPlatforms,
  routePlatformId,
  returnTo,
}) => {
  const navigate = useNavigate()
  const [resolving, setResolving] = useState(false)
  const payoutDate = row?.estimated_payout_at
  const settlementId = getSettlementOrPayoutId(row)

  const resolvedPlatform = useMemo(
    () => resolvePayoutPlatformSync(row, connectedPlatforms, routePlatformId),
    [row, connectedPlatforms, routePlatformId]
  )

  const detailLink = buildPayoutDetailPath(resolvedPlatform, payoutDate)

  const navigationState: PayoutDetailNavigationState = {returnTo, settlementId}

  const handleNavigate = async (event: React.MouseEvent) => {
    event.preventDefault()
    if (!payoutDate || resolving) return

    if (resolvedPlatform) {
      navigate(buildPayoutDetailPath(resolvedPlatform, payoutDate), {state: navigationState})
      return
    }

    setResolving(true)
    try {
      const resolved = await resolvePayoutPlatformAsync(
        row,
        connectedPlatforms,
        payoutDate,
        routePlatformId
      )
      const nextPath = buildPayoutDetailPath(resolved, payoutDate)
      if (nextPath) {
        navigate(nextPath, {state: navigationState})
      }
    } finally {
      setResolving(false)
    }
  }

  if (!payoutDate) {
    return <span className='fw-semibold'>{settlementId}</span>
  }

  if (detailLink) {
    return (
      <Link
        className='fw-semibold text-info text-decoration-none'
        to={detailLink}
        state={navigationState}
      >
        {settlementId}
      </Link>
    )
  }

  return (
    <a
      href='#'
      className={`fw-semibold text-info text-decoration-none ${
        resolving ? 'opacity-50 pe-none' : ''
      }`}
      onClick={handleNavigate}
    >
      {resolving ? 'Loading...' : settlementId}
    </a>
  )
}
